import React, { useEffect } from 'react'
import { Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { fetchUserProfile } from '../../../../../redux/action/userProfile/user-profile'
import default_image_url from '../../../../../redux/api/API'
import '../../style.scss'

const AdminCoHeader = () => {
    const {t} = useTranslation();
    let userdata = JSON.parse(localStorage.getItem("user"))
    const dispatch = useDispatch()
    const user_profile = useSelector(state => state.user_profile)

    useEffect(()=> {
        if(!user_profile.user.id) {
            dispatch(fetchUserProfile(userdata.id))
        }
    }, [])

    return (
        <div className="create">
            <div className='user_header'>
                <div className='user_image'>
                    <img src={user_profile.user.avatar ? default_image_url+user_profile.user.avatar : '/assets/img/dashboard-user.png'} />
                </div>
                <Row>
                    <div className="col-lg-3 mt-2">
                        <Link to="/dashboard/company-management" className="dashboard-create">
                            <div className='dashboard-create-image'><img src='./assets/img/stall.png' alt="stall" /></div>
                            <h6> {t("dashboard_nav_company_management")} </h6>
                        </Link>
                    </div>
                    <div className="col-lg-3 mt-2">
                        <Link to="/dashboard/categories" className="dashboard-create">
                            <div className='dashboard-create-image'><img src='./assets/img/category.png' alt="category" /></div>
                            <h6> {t("dashboard_nav_categories")} </h6>
                        </Link>
                    </div>
                    <div className="col-lg-3 mt-2">
                        <Link to="/dashboard/account" className="dashboard-create">
                            <div className='dashboard-create-image'><img src='./assets/img/account.png' alt="account" /></div>
                            <h6> {t("dashboard_nav_user_account")} </h6>
                        </Link>
                    </div>
                </Row>
            </div>
        </div>
    )
}

export default AdminCoHeader
